import React, { useMemo, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Settings from '../../../../services/settings.service';
import { Link } from 'react-router-dom';
import { urlFormatter } from '../../../../util';
import { initiateUser } from 'services/user.service';
import Translation from '../../../../services/translation.service';
import AccountSwitcher from '../AccountSwitcher';
import { logout } from 'stores/User/userActions';
import LogOutIcon from '../../../../assets/img/icon/Log in.svg';
import * as constants from '../../../../constants';
import RequirePermission from 'components/shared/RequirePermission';

const TEMPORARY_URL_PREFIX = `${Settings.REACT_APP_API_BASE_URL}images`;

const MyLebaraLoginMenu = ({
  toggleNavMain,
  toggleNav,
  resetNavList,
  links,
  selectedSubscriber,
  mobile,
  loggedIn,
  logout,
}) => {
  if (!links) return null;
  const [showSubscribersAccounts, setShowSubscribersAccounts] =
    React.useState(false);

  const showSubscribersAccountsModal = React.useCallback(() => {
    setShowSubscribersAccounts(!showSubscribersAccounts);
  }, [showSubscribersAccounts]);

  const mobileNumber = selectedSubscriber
    ? selectedSubscriber.user.mobile_number
    : mobile;

  const subscriberType =
    selectedSubscriber?.user?.properties?.subscription_type;

  // const balanceAmount = React.useMemo(() => {
  //   return (
  //     selectedSubscriber?.user.balance_details.main.amount.value +
  //     ' ' +
  //     Translation.key(
  //       selectedSubscriber?.user.balance_details.main.amount.currency
  //     )
  //   );
  // }, [selectedSubscriber]);

  const balanceAmount = React.useMemo(() => {
    if (
      selectedSubscriber?.user?.properties?.subscription_type ===
        constants.PREPAID ||
      selectedSubscriber?.subscriptionType === constants.PREPAID
    ) {
      return (
        selectedSubscriber?.user.balance_details.main?.amount.value +
        ' ' +
        Translation.key(
          selectedSubscriber?.user.balance_details.main.amount.currency
        )
      );
    } else {
      // return (
      //   selectedSubscriber?.user.balance.amount.value +
      //   ' ' +
      //   Translation.key('generic_currency_sar')
      // );
      return null;
    }
  }, [selectedSubscriber]);
  const dashboardLink =
    urlFormatter(links?.['wsc-dashboard-usage']?.['route']) ||
    urlFormatter(links?.['wsc-dashboard-usage']?.['1']?.['route']);

  const manageAccountLink =
    urlFormatter(links?.['wsc-dashboard-manage_account']?.['route']) ||
    urlFormatter(links?.['wsc-dashboard-manage_account']?.['1']?.['route']);

  const loginLink =
    urlFormatter(links?.['informative-login']?.['route']) ||
    urlFormatter(links?.['informative-login']?.[1]?.['route']);
  const [userPermissions, setUserPermissions] = useState(
    JSON.parse(localStorage.getItem('userPermissions')) || []
  );
  return (
    <>
      <li
        className="nav-list-itm border-bottom mobile-tablet-only"
        style={{ padding: '0' }}
      >
        <div
          className="nav-list-lnk pointer my-lebara-login"
          onClick={toggleNavMain}
        >
          <div className="my-lebara-data">
            <span>{Translation.key('my-lebara')}</span>
            <span className="mobile-balance">{mobileNumber}</span>
            <span className="mobile-balance">{balanceAmount}</span>
          </div>
          <div className="arrow">
            <svg
              width="10"
              height="18"
              viewBox="0 0 10 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 17L1.00016 9.00048L9 1.00048"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="sub-nav-wrapper">
          <div className="sub-nav flex-between">
            <div className="back mobile-tablet-only" onClick={resetNavList}>
              <svg
                width="10"
                height="18"
                viewBox="0 0 10 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 17L1.00016 9.00048L9 1.00048"
                  stroke="#7C8095"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>{Translation.key('my-lebara')}</span>
            </div>

            <div className="nav-section nav-section-column">
              <div className="sub-nav-list-lnk">
                <Link to={dashboardLink} onClick={toggleNav}>
                  {Translation.key('usermenu_dashboard')}
                </Link>
              </div>
              <RequirePermission permission="history">
                <div className="sub-nav-list-lnk">
                  <Link
                    to={urlFormatter(links['wsc-dashboard-history']['route'])}
                    onClick={toggleNav}
                  >
                    {Translation.key('generic_lbl_number_activity')}
                  </Link>
                </div>
              </RequirePermission>
              {subscriberType == constants.SUBSCRIPER_TYPE_POSTPAID ? (
                <RequirePermission permission="bills">
                  <div className="sub-nav-list-lnk">
                    <Link
                      to={urlFormatter(
                        links['wsc-dashboard-usage-pospaid_user_bills']['route']
                      )}
                      onClick={toggleNav}
                    >
                      {Translation.key('postpaid_dashboard_menu_label_bills')}
                    </Link>
                  </div>
                </RequirePermission>
              ) : null}
              {userPermissions.find(
                (permission) => permission.key === 'bundles'
              ) && (
                <RequirePermission permission="bundles_build_your_bundle">
                  <div className="sub-nav-list-lnk">
                    <Link
                      to={urlFormatter(
                        links['wsc-dashboard-custumize_bundle']['route']
                      )}
                      onClick={toggleNav}
                    >
                      {Translation.key('build_your_bundle')}
                    </Link>
                  </div>
                </RequirePermission>
              )}
              {subscriberType == constants.SUBSCRIPER_TYPE_PREPAID &&
              userPermissions.find(
                (permission) => permission.key === 'special_services'
              ) ? (
                <RequirePermission permission="credit_transfer">
                  <div className="sub-nav-list-lnk">
                    <Link
                      to={urlFormatter(
                        links['wsc-dashboard-credit_transfer']['route']
                      )}
                      onClick={toggleNav}
                    >
                      {Translation.key('credit_transfer_local_scrn_title')}
                    </Link>
                  </div>
                </RequirePermission>
              ) : null}
              <div className="sub-nav-list-lnk">
                <Link
                  to={urlFormatter(links['wsc-dashboard-profile']['route'])}
                  onClick={toggleNav}
                >
                  {Translation.key('web_wsc_dashboard_my_profile')}
                </Link>
              </div>
              <div className="sub-nav-list-lnk">
                <Link
                  to={urlFormatter(
                    links['wsc-dashboard-auto-payment']['route']
                  )}
                  onClick={toggleNav}
                >
                  {Translation.key('wsc-dashboard-auto-payment')}
                </Link>
              </div>
              <div className="sub-nav-list-lnk">
                <Link to={manageAccountLink} onClick={toggleNav}>
                  {Translation.key('usermenu_manage_account')}
                </Link>
              </div>
              <div
                className="sub-nav-list-lnk"
                onClick={() => {
                  initiateUser();
                  showSubscribersAccountsModal();
                }}
              >
                <a
                  href
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  {Translation.key('switch_account1.0_lbl1.0_switch_account')}
                </a>
              </div>
              <div className="sub-nav-list-lnk">
                {!loggedIn ? (
                  <Link
                    to={loginLink}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '3px',
                      cursor: 'pointer',
                    }}
                    onClick={toggleNav}
                  >
                    <img src={LogOutIcon} />
                    &nbsp;
                    <span>{Translation.key('profile_scrn_lbl1.11_login')}</span>
                  </Link>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '3px',
                    }}
                    onClick={() =>
                      logout(
                        urlFormatter(
                          links['informative-login']['route']
                        ).substr(1)
                      )
                    }
                  >
                    <img src={LogOutIcon} />
                    &nbsp;
                    <span>
                      {Translation.key('profile_scrn_lbl1.11_logout')}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </li>
      {showSubscribersAccounts ? (
        <AccountSwitcher
          showSubscribersAccountsModal={showSubscribersAccountsModal}
          toggleNav={toggleNav}
        />
      ) : (
        ''
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  loggedIn: state.user.loggedIn,
  links: state.layout.routes,
  mobile: state.user.mobile_number,
  selectedSubscriber: state.user.selectedSubscriber,
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ logout }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(MyLebaraLoginMenu);
